import VerifyAccount from '../VerifyAccount/VerifyAccount';
import GraduateUserContext from '../../contexts/GraduateUserContext';
import { TBusiness, TUser } from '../../util/types';
import API from '../../api/api';
import { FC, useContext, useEffect, useMemo } from 'react';

const GraduateUserSuccess: FC = () => {
    const { businesses, firstName, lastName, userId, legacySyncToken } = useContext(GraduateUserContext);

    const primaryUser: TUser = {
        firstName,
        lastName,
        id: userId,
    };
    const userBusinesses: TBusiness[] = useMemo(() => {
        const parsedBusinesses = businesses.map((business) => ({
            users: [
                {
                    id: primaryUser.id,
                    firstName: primaryUser.firstName,
                    lastName: primaryUser.lastName,
                },
            ],
            name: business.name,
            city: business.locality,
            stateOrProvince: business.region,
            countryCode: business.countryCode,
            subscriberId: business.id.toString(),
        }));
        return parsedBusinesses;
    }, [businesses]);

    useEffect(() => {
        API.post.trackEvent({ event: 'Sign In || Verification Complete' });
    });

    return (
        <>
            <VerifyAccount
                businesses={userBusinesses}
                primaryUser={primaryUser}
                hasFamilyUsers={false}
                legacySyncToken={legacySyncToken}
                onFindBusinesses={() =>
                    API.post.trackEvent({
                        event: 'Sign In || Verification Complete | Button - Search for them (Manual Sync)',
                    })
                }
            />
        </>
    );
};

export default GraduateUserSuccess;
